export const DOWNLOAD_CXM = 'DOWNLOAD_CXM';
export const DOWNLOAD_POS = 'DOWNLOAD_POS';
export const DOWNLOAD_MOBILE_POS = 'DOWNLOAD_MOBILE_POS';
export const DOWNLOAD_MOBILE_STALL = 'DOWNLOAD_MOBILE_STALL';